/* pb-galerie-conseil.js — comportements du conseil et de la pastille ronde (lot 2, accueil « Galerie des maisons », 15/10/2026).
   Sans bibliothèque. Aucune règle globale. Rien n'est écrit sur le serveur. Chargé une seule fois (drapeau window.__pbgcInit).
   1. Ouvrir l'assistant guidé SANS IA : section pb-conciergerie-contact v3 (#conciergerie > details.pbcc__box), JAMAIS réécrite.
      Tout élément [data-pbgc-ouvrir] : si #conciergerie existe, on déplie l'assistant et on le centre ; sinon le lien (page Contact) suit son cours.
      Aussi : l'ancre #conciergerie dans l'adresse, et ?conseil=1, déplient l'assistant.
   2. Pastille ronde : visible seulement en remontant (après 400 px), jamais sur les zones sans pastille, ni pendant le bandeau de consentement,
      un tiroir ouvert ou un champ actif, et jamais au-dessus d'un titre ou d'un prix (mesure sur les lignes de texte réelles). */
(function () {
  'use strict';
  if (window.__pbgcInit) return; window.__pbgcInit = true;
  var d = document, w = window;
  function reduit() { try { return w.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }

  /* ---------- 1. L'assistant guidé ---------- */
  function ouvrirAssistant(defiler) {
    var s = d.getElementById('conciergerie'); if (!s) return false;
    var box = s.querySelector('details.pbcc__box'); if (!box) return false;
    box.open = true;
    if (defiler !== false) { try { s.scrollIntoView({ behavior: reduit() ? 'auto' : 'smooth', block: 'center' }); } catch (e) { s.scrollIntoView(); } }
    var sm = box.querySelector('summary'); if (sm) { try { sm.focus({ preventScroll: true }); } catch (e) {} }
    return true;
  }
  w.pbgcOuvrirConseil = function () { return ouvrirAssistant(true); };
  d.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var a = t.closest('[data-pbgc-ouvrir]'); if (!a) return;
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (ouvrirAssistant(true)) e.preventDefault();
  });
  function depuisAdresse() {
    var q = ''; try { q = new URLSearchParams(location.search).get('conseil'); } catch (e) {}
    if (location.hash === '#conciergerie') ouvrirAssistant(false);
    else if (q === '1') ouvrirAssistant(true);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', depuisAdresse); else depuisAdresse();
  w.addEventListener('hashchange', depuisAdresse);

  /* ---------- 2. La pastille ---------- */
  function init() {
    var past = d.querySelector('[data-pbgc-pastille]'); if (!past) return;
    // Rangée à la racine du document : un ancêtre à transform, filter ou content-visibility ferait de lui le repère de position:fixed
    if (past.parentNode !== d.body) d.body.appendChild(past);
    var SEUIL = 400;                                           // px de défilement avant la 1re apparition
    var ZONES = '[data-pbgc-sans-pastille],[data-pbg-index],#conciergerie,footer,.footer,#maisons,[id*="galerie-index"],[id*="galerie_index"],[id*="index-maisons"],[id*="index_maisons"],[class*="pbg-index"]';
    var TEXTES = 'h1,h2,h3,h4,h5,h6,[class*="price"],[class*="prix"],[class*="__nom"],[class*="__maison"],[class*="__titre"],[class*="card__heading"]';
    var visibles = [], haut = 0, bas = 0, remonte = false, y0 = w.pageYOffset, nbHaut = 0, nbBas = 0;
    var timer = null, enCours = false, cache = [], cacheT = 0, G = { r: 16, b: 16, s: 56 };

    function mesures() { try { var cs = w.getComputedStyle(past); G.r = parseFloat(cs.right) || 16; G.b = parseFloat(cs.bottom) || 16; G.s = past.offsetWidth || 56; } catch (e) {} }
    mesures(); w.addEventListener('resize', mesures);

    // zones où la pastille n'a pas lieu d'être
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var i = visibles.indexOf(e.target); if (e.isIntersecting) { if (i < 0) visibles.push(e.target); } else if (i >= 0) visibles.splice(i, 1); });
        planifier();
      });
      [].forEach.call(d.querySelectorAll(ZONES), function (z) { if (!past.contains(z)) io.observe(z); });
    }
    function bandeau() { var b = d.getElementById('shopify-pc__banner'); if (!b) return false; try { return b.offsetHeight > 0 && w.getComputedStyle(b).visibility !== 'hidden'; } catch (e) { return false; } }
    function tiroir() { return d.body.classList.contains('overflow-hidden'); }
    function champ() { var a = d.activeElement; return !!(a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)); }

    // jamais au-dessus d'un titre ou d'un prix : on mesure les lignes de texte réelles sous le cercle
    function collision() {
      var W = d.documentElement.clientWidth, H = w.innerHeight, m = 8;
      var bx = { l: W - G.r - G.s - m, r: W - G.r + m, t: H - G.b - G.s - m, b: H - G.b + m };
      var now = Date.now(); if (now - cacheT > 1500) { cache = [].slice.call(d.querySelectorAll(TEXTES)); cacheT = now; }
      var rg = d.createRange();
      for (var i = 0; i < cache.length; i++) {
        var el = cache[i]; if (past.contains(el)) continue;
        var r = el.getBoundingClientRect();
        if (r.width === 0 || r.height === 0 || r.right < bx.l || r.left > bx.r || r.bottom < bx.t || r.top > bx.b) continue;
        try {
          rg.selectNodeContents(el);
          var rs = rg.getClientRects();
          for (var k = 0; k < rs.length; k++) { var q = rs[k]; if (q.width > 0 && q.height > 0 && q.right > bx.l && q.left < bx.r && q.bottom > bx.t && q.top < bx.b) return true; }
        } catch (e) { return true; }
      }
      return false;
    }
    function permis() {
      return remonte && w.pageYOffset > SEUIL && visibles.length === 0 && !bandeau() && !tiroir() && !champ() && !collision();
    }
    function montrer() { past.classList.add('est-visible'); }
    function cacher() { past.classList.remove('est-visible'); }
    function maj() {
      enCours = false;
      if (!permis()) { clearTimeout(timer); timer = null; cacher(); return; }
      if (!past.classList.contains('est-visible') && !timer) {
        timer = setTimeout(function () { timer = null; if (permis()) montrer(); }, 160);   // elle attend que le défilement se calme
      }
    }
    function planifier() { if (!enCours) { enCours = true; w.requestAnimationFrame(maj); } }

    w.addEventListener('scroll', function () {
      var y = w.pageYOffset, dy = y - y0; y0 = y;
      if (dy < 0) { nbHaut += -dy; nbBas = 0; if (nbHaut >= 24) remonte = true; }
      else if (dy > 0) { nbBas += dy; nbHaut = 0; if (nbBas >= 8) remonte = false; }
      planifier();
    }, { passive: true });
    w.addEventListener('resize', planifier);
    d.addEventListener('focusin', planifier); d.addEventListener('focusout', planifier);
    // un onglet ou un tiroir qui change la page : on revérifie
    d.addEventListener('click', function () { cacheT = 0; setTimeout(planifier, 60); });
    planifier();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
